import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  payloadDetails: {
    loading: false,
    errorMessage: '',
    successMessage: '',
    customer: {},
    billingAddress: {},
    orderToken: '',
    uuid: '',
    expiresOn: '',
    created: '',
    orderItems: [],
    currency: '',
    data: {},
  },
  quoteDetails: {
    loading: false,
    errorMessage: '',
    successMessage: '',
    quote: [],
    symbol: '',
    quoteLiteral: '',
    surcharge: '',
    underwriter: {},
    data: {},
  },
  orderDetails: {
    loading: false,
    errorMessage: '',
    successMessage: '',
    orderNumber: '',
    data: {},
  },
  openEndedTokenDetails: {
    loading: false,
    errorMessage: '',
    successMessage: '',
    data: {},
    client: {},
    currency: '',
    currencySymbol: '',
    isExpired: false,
    url: '',
  },
  internalQuoteDetails: {
    loading: false,
    errorMessage: '',
    successMessage: '',
    data: {},
    currency: '',
    quoteLiteral: '',
    orderLiteral: '',
    quote: [],
    total: '',
    symbol: '',
    underwriter: '',
  },
  globalQuotedTicketsDetails: {
    loading: false,
    errorMessage: '',
    successMessage: '',
    globalQuotedTickets: {},
    count: 0,
    userInformation: {},
  },
  pcwTokenDetails: {
    loading: false,
    errorMessage: '',
    successMessage: '',
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
